<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{params.title}}</div>
    <div slot="body">
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('op_7')" v-bind="formItemLayout">
          <icon-checkbox v-decorator="decorators.cloudsupplier_allowlist" :options="grayscaleCloudsupplierOpts" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import IconCheckbox from '@/sections/IconCheckbox'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'AllowCloudSuppliersDialog',
  components: {
    IconCheckbox,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        cloudsupplier_allowlist: [
          'cloudsupplier_allowlist',
          {
            rules: [
              { required: true, message: this.$t('op_8') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      grayscaleCloudsupplierList: [],
      publishedCloudsupplierList: [],
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    grayscaleCloudsupplierOpts () {
      const ret = []
      this.grayscaleCloudsupplierList.map(item => {
        ret.push({
          icon: item.provider.toLowerCase(),
          label: item.provider,
          key: item.id,
        })
      })
      return ret
    },
  },
  created () {
    this.cloudsuppliersM = new this.$Manager('cloudsuppliers')
    this.customersM = new this.$Manager('customers')
    this.fetchPublishedCloudsuppliers()
    this.fetchGrayscaleCloudsuppliers()
  },
  methods: {
    async fetchGrayscaleCloudsuppliers () {
      const { data: { data } } = await this.cloudsuppliersM.list({
        params: {
          scope: this.scope,
          published: false,
        },
      })
      this.grayscaleCloudsupplierList = data
    },
    async fetchPublishedCloudsuppliers () {
      const { data } = await this.customersM.getSpecific({
        id: this.params.data[0].id,
        spec: 'metadata',
        params: {
          scope: this.scope,
        },
      })
      this.publishedCloudsupplierList = data.__alpha_profile__ ? JSON.parse(data.__alpha_profile__).cloudsupplier_allowlist : []
      if (this.publishedCloudsupplierList.length > 0) {
        this.$nextTick(() => {
          this.form.fc.getFieldDecorator('cloudsupplier_allowlist', { initialValue: this.publishedCloudsupplierList, preserve: true })
        })
      }
    },
    doPublish (data) {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: 'alpha-test-profile',
          data,
        },
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.doPublish(values)
        this.loading = false
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
